import React, {useEffect, useState} from "react"
import {Modal, Spin, Table} from "antd"
import moment from "moment"
import {API_DOMAIN} from "../../../config"
import {fetchData} from "../../../util"
import {purchaseServices} from "../../../api/employee"

const ComplaintDetailOrder = ({order, type}) => {
    const [showBusinessDetailModal, setShowBusinessDetailModal] = useState(false)
    const [requested, setRequested] = useState(false)
    const [showPrepaidDetailModal, setShowPrepaidDetailModal] = useState(false)
    const orderColumns = [
        {
            key: 1, label: "消费记录", value: [
                {
                    title: '类型',
                    dataIndex: 'label',
                    key: 'label',
                },
                {
                    title: 'ID',
                    dataIndex: 'id',
                    key: 'id',
                },
                {
                    title: '订单号',
                    dataIndex: 'temporaryNumber',
                    key: 'temporaryNumber',
                },
                {
                    title: '流水号',
                    dataIndex: 'serialNumber',
                    key: 'serialNumber',
                },
                {
                    title: '台名',
                    dataIndex: 'tableName',
                    key: 'tableName',
                },
                {
                    title: '名称',
                    dataIndex: 'nickname',
                    key: 'nickname',
                },
                {
                    title: '支付账号',
                    dataIndex: 'account',
                    key: 'account',
                },
                {
                    title: '支付时间',
                    dataIndex: 'payingTime',
                    key: 'time',
                },
                {
                    title: '支付方式',
                    dataIndex: 'payingTypeName',
                    key: 'payingTypeName',
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    key: 'operation',
                    render: (text, record) => (
                        <div style={{color: '#108EE9', cursor: 'default'}}
                             onClick={() => getBusinessDetail(record)}>详情
                        </div>
                    )
                },
            ]
        },
        {
            key: 2, label: "套餐记录", value: [
                {
                    title: '类型',
                    dataIndex: 'label',
                    key: 'label',
                },
                {
                    title: 'ID',
                    dataIndex: 'id',
                    key: 'id',
                },
                {
                    title: '订单号',
                    dataIndex: 'temporaryNumber',
                    key: 'temporaryNumber'
                },
                {
                    title: '开始时间',
                    dataIndex: 'startTime',
                    key: 'startTime'
                },
                {
                    title: '结束时间',
                    dataIndex: 'endTime',
                    key: 'endTime'
                },
                {
                    title: '台名',
                    dataIndex: 'tableName',
                    key: 'tableName',
                },
                {
                    title: '套餐名称',
                    dataIndex: 'prepaidName',
                    key: 'prepaidName',
                },
                {
                    title: '金额',
                    dataIndex: 'amount',
                    key: 'amount',
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    key: 'operation',
                    render: () => (
                        <div style={{color: '#108EE9', cursor: 'default'}}
                             onClick={() => setShowPrepaidDetailModal(true)}>详情
                        </div>
                    )
                },
            ]
        },
        {
            key: 3, label: "充值记录", value: [
                {
                    title: '类型',
                    dataIndex: 'label',
                    key: 'label',
                },
                {
                    title: 'ID',
                    dataIndex: 'id',
                    key: 'id',
                },
                {
                    title: '用户',
                    dataIndex: 'nickname',
                    key: 'nickname',
                },
                {
                    title: '流水号',
                    dataIndex: 'serialNumber',
                    key: 'serialNumber',
                },
                {
                    title: '充值账号',
                    dataIndex: 'account',
                    key: 'account',
                },
                {
                    title: '支付方式',
                    dataIndex: 'payingTypeName',
                    key: 'payingTypeName',
                },
                {
                    title: '充值钱包',
                    dataIndex: 'walletName',
                    key: 'walletName',
                },
                {
                    title: '充值金额',
                    dataIndex: 'amount',
                    key: 'amount'
                },
                {
                    title: '充值时间',
                    dataIndex: 'payingTime',
                    key: 'payingTime',
                },
                {
                    title: '操作人',
                    dataIndex: 'employeeName',
                    key: 'employeeName',
                },
            ]
        },
        {
            key: 4, label: "卡券记录", value: [
                {
                    title: '类型',
                    dataIndex: 'label',
                    key: 'label',
                },
                {
                    title: '用户',
                    dataIndex: 'nickname',
                    key: 'nickname',
                },
                {
                    title: '流水号',
                    dataIndex: 'serialNumber',
                    key: 'serialNumber',
                },
                {
                    title: '购买账号',
                    dataIndex: 'account',
                    key: 'account',
                },
                {
                    title: '卡券面额',
                    dataIndex: 'couponAmount',
                    key: 'couponAmount',
                },
                {
                    title: '卡券名称',
                    dataIndex: 'couponName',
                    key: 'couponName',
                },
                {
                    title: '卡券类型',
                    dataIndex: 'couponTypeName',
                    key: 'couponTypeName',
                },
                {
                    title: '购买金额',
                    dataIndex: 'amount',
                    key: 'amount'
                },
                {
                    title: '购买时间',
                    dataIndex: 'payingTime',
                    key: 'payingTime'
                },
            ]
        },
        {
            key: 5, label: "预订记录", value: [
                {
                    title: '类型',
                    dataIndex: 'label',
                    key: 'label',
                },
                {
                    title: 'ID',
                    dataIndex: 'id',
                    key: 'id',
                },
                {
                    title: '台名',
                    dataIndex: 'tableName',
                    key: 'tableName',
                },
                {
                    title: '用户',
                    dataIndex: 'nickname',
                    key: 'nickname',
                },
                {
                    title: '手机号',
                    dataIndex: 'phone',
                    key: 'phone',
                },
                {
                    title: '开始时间',
                    dataIndex: 'startTime',
                    key: 'startTime'
                },
                {
                    title: '结束时间',
                    dataIndex: 'endTime',
                    key: 'endTime'
                },
                {
                    title: '状态',
                    dataIndex: 'stateDescription',
                    key: 'stateDescription'
                },
                {
                    title: '支付时间',
                    dataIndex: 'payingTime',
                    key: 'payingTime',
                },
                {
                    title: '支付金额',
                    dataIndex: 'amount',
                    key: 'amount',
                },
                {
                    title: '预订方式',
                    dataIndex: 'type',
                    key: 'type',
                },
                {
                    title: '到店时间',
                    dataIndex: 'consumeTime',
                    key: 'consumeTime'
                },
            ]
        }
    ]
    const prepaidDetailColumns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '流水号',
            dataIndex: 'serialNumber',
            key: 'serialNumber'
        },
        {
            title: '账户',
            dataIndex: 'account',
            key: 'account',
        },
        {
            title: '支付时间',
            dataIndex: 'payingTime',
            key: 'payingTime',
        },
        {
            title: '支付方式',
            dataIndex: 'payingTypeName',
            key: 'payingTypeName',
        },
        {
            title: '金额',
            dataIndex: 'amount',
            key: 'amount',
        },
    ]
    const [columns, setColumns] = useState([])
    const [dataSource, setDataSource] = useState([])
    const [businessList, setBusinessList] = useState([
        {
            label: "回合消费",
            columns: [
                {
                    title: '球台',
                    dataIndex: 'tableName',
                    key: 'tableName',
                },
                {
                    title: '开始时间',
                    dataIndex: 'startTime',
                    key: 'startTime',
                },
                {
                    title: '结束时间',
                    dataIndex: 'endTime',
                    key: 'endTime',
                },
                {
                    title: '上场玩家',
                    dataIndex: 'fAccount',
                    key: 'fAccount',
                },
                {
                    title: '计钟玩家',
                    dataIndex: 'account',
                    key: 'account',
                },
                {
                    title: '时长',
                    dataIndex: 'num',
                    key: 'num',
                },
                {
                    title: '总金额',
                    dataIndex: 'price',
                    key: 'price',
                },
                {
                    title: '原价',
                    dataIndex: 'originPrice',
                    key: 'originPrice',
                },
                {
                    title: '单价',
                    dataIndex: 'uPrice',
                    key: 'uPrice',
                },
                {
                    title: '奖金',
                    dataIndex: 'profit',
                    key: 'profit',
                },
                {
                    title: '串台',
                    dataIndex: 'status',
                    key: 'status',
                },
                {
                    title: '暂停',
                    dataIndex: 'stopFlag',
                    key: 'stopFlag',
                },
            ],
            value: []
        },
        {
            label: "商品消费",
            columns: [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    key: 'id',
                },
                {
                    title: '账号',
                    dataIndex: 'account',
                    key: 'account',
                },
                {
                    title: '用户',
                    dataIndex: 'nickname',
                    key: 'nickname',
                },
                {
                    title: '商品名',
                    dataIndex: 'goodName',
                    key: 'goodName',
                },
                {
                    title: '台名',
                    dataIndex: 'tableName',
                    key: 'tableName',
                },
                {
                    title: '购买时间',
                    dataIndex: 'payingTime',
                    key: 'payingTime',
                },
                {
                    title: '数量',
                    dataIndex: 'num',
                    key: 'num',
                },
                {
                    title: '总金额',
                    dataIndex: 'price',
                    key: 'price',
                },
                {
                    title: '单价',
                    dataIndex: 'uPrice',
                    key: 'uPrice',
                },
            ],
            value: []
        },
        {
            label: "服务消费",
            columns: [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    key: 'id',
                },
                {
                    title: '账号',
                    dataIndex: 'account',
                    key: 'account',
                },
                {
                    title: '用户',
                    dataIndex: 'nickname',
                    key: 'nickname'
                },
                {
                    title: '球台',
                    dataIndex: 'tableName',
                    key: 'tableName',
                },
                {
                    title: '开始时间',
                    dataIndex: 'startTime',
                    key: 'startTime',
                },
                {
                    title: '结束时间',
                    dataIndex: 'endTime',
                    key: 'endTime',
                },
                {
                    title: '服务',
                    dataIndex: 'service',
                    key: 'service',
                },
                {
                    title: '服务员',
                    dataIndex: 'serviceName',
                    key: 'serviceName',
                },
                {
                    title: '时长',
                    dataIndex: 'num',
                    key: 'num',
                },
                {
                    title: '总金额',
                    dataIndex: 'price',
                    key: 'price',
                },
                {
                    title: '单价',
                    dataIndex: 'uPrice',
                    key: 'uPrice',
                },
            ],
            value: []
        }
    ])
    const [businessInfo, setBusinessInfo] = useState({
        nickname: '',
        account: '',
        price: ''
    })

    useEffect(() => {
        orderColumns.forEach((item) => {
            if (item.key === type) {
                setColumns(item.value)
                handleType(item.key, item.label)
            }
        })
    }, [type])

    /**
     * 根据类型处理
     */
    const handleType = (type, label) => {
        if (type === 1) {
            const {bill, table, member, wallet} = order
            setDataSource([{
                label: label,
                id: bill.id,
                temporaryNumber: bill.temporaryNumber,
                serialNumber: bill.serialNumber,
                tableName: table.name,
                nickname: member.nickName,
                account: bill.account,
                payingTime: moment(bill.time).format('YYYY-MM-DD HH:mm:ss'),
                payingTypeName: wallet.name
            }])
        } else if (type === 2) {
            const {bill, prepaid, prepaidState, member, table} = order
            setDataSource([{
                label: label,
                id: bill.id,
                temporaryNumber: prepaidState.tableStateId,
                serialNumber: bill.serialNumber,
                startTime: moment(prepaidState.startTime).format('YYYY-MM-DD HH:mm:ss'),
                endTime: moment(prepaidState.endTime).format('YYYY-MM-DD HH:mm:ss'),
                tableName: table.name,
                prepaidName: prepaid.name,
                account: member.account,
                payingTime: moment(bill.time).format('YYYY-MM-DD HH:mm:ss'),
                payingTypeName: getPayingTypeName(bill.payingId),
                amount: (bill.amount / 100).toFixed(2)
            }])
        } else if (type === 3) {
            const {bill, member, wallet, employee} = order
            setDataSource([{
                label: label,
                id: bill.id,
                nickname: member.nickName,
                serialNumber: bill.serialNumber,
                account: member.account,
                payingTypeName: getPayingTypeName(bill.payingId),
                walletName: wallet.name,
                amount: (bill.amount / 100).toFixed(2),
                payingTime: moment(bill.updateTime).format('YYYY-MM-DD HH:mm:ss'),
                employeeName: employee && employee.name ? employee.name : '-',
            }])
        } else if (type === 4) {
            const {bill, coupon, member} = order
            setDataSource([{
                label: label,
                nickname: member.nickName,
                serialNumber: bill.serialNumber,
                account: member.account,
                couponAmount: coupon.denomination,
                couponName: coupon.name,
                couponTypeName: getCouponTypeName(coupon.typeId),
                amount: ((bill.amount ? bill.amount : 0) / 100).toFixed(2),
                payingTime: moment(bill.updateTime).format('YYYY-MM-DD HH:mm:ss'),
            }])
        } else if (type === 5) {
            const {bill, member, table} = order
            setDataSource([{
                label: label,
                id: bill.id,
                serialNumber: bill.serialNumber,
                tableName: table.name,
                nickname: member.nickName,
                phone: bill.phone,
                startTime: moment(bill.startTime).format('YYYY-MM-DD HH:mm:ss'),
                endTime: moment(bill.endTime).format('YYYY-MM-DD HH:mm:ss'),
                stateDescription: bill.stateDescription,
                payingTime: bill.state !== 1 ? moment(bill.payingTime).format('YYYY-MM-DD HH:mm:ss') : '-',
                amount: ((bill.originAmount ? bill.originAmount : 0) / 100).toFixed(2),
                type: getRechargeTypeName(bill.type),
                consumeTime: bill.consumeTime !== '1970-01-01T08:00:00+08:00' ? moment(bill.consumeTime).format('YYYY-MM-DD HH:mm:ss') : '-'
            }])
        }
    }

    const getRechargeTypeName = (typeId) => {
        switch (typeId) {
            case 1:
                return '代客'
            case 2:
                return '自助'
            default:
                return '未知'
        }
    }

    const getCouponTypeName = (typeId) => {
        switch (typeId) {
            case 1:
                return '金额券'
            case 2:
                return '时长券'
            default:
                return '未知'
        }
    }

    const getPayingTypeName = (payingId) => {
        switch (payingId) {
            case 0:
                return '余额'
            case 1:
                return '现金'
            case 2:
                return '微信'
            case 3:
                return '第三方'
            case 4:
                return '签单'
            case 5:
                return '无效'
            case 6:
                return '银行卡'
            case 7:
                return '挂帐'
            case 8:
                return '俱乐部余额'
            case 9:
                return '团购'
            case 11:
                return '充送'
            case 13:
                return '支付宝'
            default:
                return '未知'
        }
    }

    const getIdentityTypeName = (typeId) => {
        switch (typeId) {
            case 1:
                return '助教'
            case 2:
                return '记分员'
            default:
                return '未知'
        }
    }

    const getBusinessDetail = async (record) => {
        try {
            setRequested(true)

            let {temporaryNumber, serialNumber, nickname, account} = record

            let roundBusiness = []
            let goodBusiness = []

            const endPoint = `${API_DOMAIN}/BusinessApi/RecordDetails/sn/${serialNumber}`
            const res = await fetchData(endPoint)
            if (res.status !== undefined) {
                return
            }

            roundBusiness = res.list.length > 0 ? res.list.map(item => {
                return {
                    tableName: item.tname,
                    startTime: item.start_time,
                    endTime: item.time,
                    fAccount: item.faccount,
                    account: item.account,
                    num: item.num,
                    price: item.price,
                    originPrice: item.origin_price,
                    uPrice: item.uprice,
                    profit: item.profit,
                    status: item.status,
                    stopFlag: item.stop_flag
                }
            }) : []
            goodBusiness = res.goodsList.length > 0 ? res.goodsList.map(item => {
                return {
                    id: item.id,
                    account: item.account,
                    nickname: item.nickname,
                    goodName: item.cname,
                    tableName: item.tname,
                    payingTime: item.time,
                    num: item.num,
                    price: item.price,
                    uPrice: item.uprice,
                }
            }) : []

            let serviceBusiness = []

            async function handleBusiness(res) {
                if (res.status === 1) {
                    serviceBusiness = res.data.length > 0 ? res.data.map(item => {
                        let {member, employee, service} = item
                        return {
                            id: service.id,
                            account: member.account,
                            nickname: member.nickName,
                            tableName: service.tableTitle,
                            startTIme: moment(service.startTime).format('YYYY-MM-DD HH:mm'),
                            endTime: moment(service.endTime).format('YYYY-MM-DD HH:mm'),
                            service: getIdentityTypeName(service.identityType),
                            serviceName: employee.name,
                            num: (service.duration / 3600).toFixed(2),
                            price: (service.amount ? service.amount : 0 / 100).toFixed(2),
                            uPrice: (service.unitAmount ? service.unitAmount : 0 / 100).toFixed(2),
                        }
                    }) : []
                }
            }

            await purchaseServices({temporaryNumbers: temporaryNumber}).then(res => {
                handleBusiness(res)
            })
            await purchaseServices({serialNumbers: serialNumber}).then(res => {
                handleBusiness(res)
            })

            const combinedList = [roundBusiness, goodBusiness, serviceBusiness]
            await setBusinessList(prevState => combinedList.map((item, index) => {
                return {
                    ...prevState[index],
                    value: item
                }
            }))

            setBusinessInfo({
                nickname: nickname,
                account: account,
                price: res.prices
            })
            setShowBusinessDetailModal(true)
        } catch (e) {
            setShowBusinessDetailModal(false)
        } finally {
            setRequested(false)
        }
    }

    return (
        <div className="complaint-detail-order-container">
            {columns.length > 0 && dataSource.length > 0 && (
                <div style={{padding: "0 0 30px"}}>
                    <div style={{fontWeight: "bold", fontSize: "15px", marginBottom: 10, padding: "0 15px"}}>订单信息
                    </div>
                    <Spin spinning={requested} delay={500}>
                        <Table columns={columns} dataSource={dataSource}
                               rowKey={"id"} pagination={false}></Table>
                    </Spin>
                </div>
            )}

            <Modal open={showPrepaidDetailModal} title={'消费详情'} width={1200} footer={null}
                   onCancel={() => setShowPrepaidDetailModal(false)}>
                <Table columns={prepaidDetailColumns} dataSource={dataSource}
                       rowKey={"id"} pagination={false}/>
            </Modal>

            <Modal open={showBusinessDetailModal} title={'消费详情'} width={1300} footer={null}
                   onCancel={() => setShowBusinessDetailModal(false)}>
                <div style={{padding: "0 15px"}}>
                    {businessList.map((item, index) => (
                        <div key={index} style={{marginBottom: 20}}>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: "15px",
                                marginLeft: "10px"
                            }}>{item.label}</div>
                            <Table columns={item.columns} dataSource={item.value} rowKey={"id"}
                                   pagination={{pageSize: 5}}/>
                        </div>
                    ))}
                    <div style={{display: "flex", margin: "20px 0", fontSize: "16px"}}>
                        <div>名称：{businessInfo.nickname}</div>
                        <div style={{margin: "0 30px"}}>支付账号：{businessInfo.account}</div>
                        <div>付款金额：&yen;{businessInfo.price}</div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default ComplaintDetailOrder


// WEBPACK FOOTER //
// ./src/containers/ClubComplaintManager/component/ComplaintDetailOrder.js